var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheEmperor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.52 397.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.34,
    y1: 168.94,
    x2: 313.19,
    y2: 24.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.62,
    y1: 168.94,
    x2: 24.33,
    y2: 24.33
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.33,
    y1: 373.27,
    x2: 170.48,
    y2: 373.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 316.62,
    y1: 373.27,
    x2: 170.48,
    y2: 373.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.48,
    y1: 86.42,
    x2: 170.48,
    y2: 373.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.73 97.82 161.77 86.42 150.73 75.02 166.12 78.88 170.48 63.61 174.83 78.88 190.23 75.02 179.19 86.42 190.23 97.82 174.83 93.96 170.48 109.23 166.12 93.96 150.73 97.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.16 358.11 24.33 365.08 39.5 358.11 32.52 373.27 39.5 388.44 24.33 381.47 9.16 388.44 16.14 373.27 9.16 358.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.48 351.82 176.27 367.48 191.93 373.27 176.27 379.07 170.48 394.72 164.68 379.07 149.03 373.27 164.68 367.48 170.48 351.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.34 147.49 229.13 163.14 244.79 168.94 229.13 174.73 223.34 190.39 217.55 174.73 201.89 168.94 217.55 163.14 223.34 147.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "313.19 2.88 318.98 18.54 334.63 24.33 318.98 30.12 313.19 45.78 307.39 30.12 291.74 24.33 307.39 18.54 313.19 2.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "117.62 147.49 123.41 163.14 139.06 168.94 123.41 174.73 117.62 190.39 111.82 174.73 96.17 168.94 111.82 163.14 117.62 147.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.33 2.88 30.12 18.54 45.78 24.33 30.12 30.12 24.33 45.78 18.54 30.12 2.88 24.33 18.54 18.54 24.33 2.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "331.79 358.11 324.82 373.27 331.79 388.44 316.62 381.47 301.46 388.44 308.43 373.27 301.46 358.11 316.62 365.08 331.79 358.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheEmperor);
export default __webpack_public_path__ + "static/media/TheEmperor.804ace20105d323a1274fa2d121408f7.svg";
export { ForwardRef as ReactComponent };